<div class="zk-flex zk-flex-col zk-gap-2 accordion-wrapper" (click)="toggleIsOpen()" (keyup)="$event.key === 'Enter' ? toggleIsOpen() : null">
	<div class="zk-flex zk-flex-row zk-items-center zk-gap-1 accordion-header">
		<span class="freud-icon freud-icon-md accordion-icon" [ngClass]="'freud-icon-' + icon"></span>
		<p freud-typography fontType="h5SemiboldAuto">
			{{ title }}
		</p>
		<freud-tag *ngIf="tag" color="warning" [value]="tag"></freud-tag>
		<span class="freud-icon freud-icon-chevron-down accordion-icon" [ngClass]="{ 'chevron-upside-down' : isOpen }"></span>
	</div>
	<div *ngIf="isOpen">
		<ng-content></ng-content>
	</div>
</div>